import React from 'react';
import IndexComponent from "../features/Register/Components/index";

function Register() {
  return (
    <IndexComponent />
  );
}

export default Register;
